const config = {
  apiKey: 'AIzaSyAdsJdyTPOqQhxgV3ynuFAJkmIC0xlYarE',
  authDomain: 'results-firebase.firebaseapp.com',
  databaseURL: 'https://results-firebase.firebaseio.com',
  projectId: 'results-firebase',
  storageBucket: 'results-firebase.appspot.com',
  messagingSenderId: '174607933138',
}

module.exports = config
